import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CreateNewJob from "./components/CreateNewJob";
// import './App.css';
// import CheckStockPage from "./components/CheckStockPage";
// import CustomerDetailsPage from "./components/CustomerDetailsPage";
import HomePage from "./components/HomePage";
import LandingPage from "./components/LandingPage";
import LoginPage from "./components/LoginPage";
// import MakeOrderPage from "./components/MakeOrderPage";
// import PreviousOrderDetailPage from "./components/PreviousOrderDetailPage";
// import PreviousOrderPage from "./components/PreviousOrderPage";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {

  //const root_url = "http://cubixsupport.com/new_bharath_test";
  const root_url = ""

  return (
    <Router>

      <Routes>
        <Route exact path={`${root_url}/`} element={<LandingPage />} />
        <Route exact path={`${root_url}/login`} element={<LoginPage />} />
        {/* <Route exact path={`${root_url}/home`} element={<HomePage />} /> */}
        {/* <Route exact path={`${root_url}/create-new-job`} element={<CreateNewJob />} /> */}

        <Route
          path="/home"
          element={
            <ProtectedRoute >
              <HomePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create-new-job"
          element={
            <ProtectedRoute >
              <CreateNewJob />
            </ProtectedRoute>
          }
        />


        {/* <Route
          path="/customer_details"
          element={
            <ProtectedRoute >
              <CustomerDetailsPage />
            </ProtectedRoute>
          }
        /> */}
        {/* <Route
          path="/make_order"
          element={
            <ProtectedRoute >
              <MakeOrderPage />
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path="/previous_order"
          element={
            <ProtectedRoute >
              <PreviousOrderPage />
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path="/previous-order-details/:id"
          element={
            <ProtectedRoute >
              <PreviousOrderDetailPage />
            </ProtectedRoute>
          }
        /> */}

      </Routes>

    </Router>
  );
}

export default App;
